// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__1Zgdh","contentWrapper":"Footer_contentWrapper__1Muva","contactLink":"Footer_contactLink__1A0TB"};